import AxiosInstance from 'src/shared/services/axios/interceptor';
import { District } from 'src/shared/models/district/district';
import { PagedResult } from 'src/shared/models/pagedResult';
import { DistrictRequest } from 'src/modules/district/models/districtRequest';
import { DistrictTitleConfigResponse } from 'src/modules/district/models/districtTitleConfigResponse';
import { DistrictTitleResponse } from 'src/modules/district/models/districtTitleResponse';
import { DistrictTitleRequest } from 'src/modules/district/models/districtTitleRequest';
import { DistrictTitleConfigRequest } from 'src/modules/district/models/districtTitleConfigRequest';
import { DistrictUserResponse } from 'src/modules/district/models/districtUserResponse';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'District';

export const getDistricts = (pageIndex, pageSize, sortCol, sortDir, withAssociations = true) => {
  let extraQuery = '';
  extraQuery += withAssociations ? `&withAssociations=${withAssociations}` : '';

  const endpoint = `${controller}?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<District>>(endpoint);
};

export const getDistrictById = (id: string | undefined) => {
  return AxiosInstance.get<District>(`${controller}/${id}`);
};

export const updateDistrict = (data: DistrictRequest) => {
  return AxiosInstance.put(controller, data);
};

export const getDistrictUsers = (id: string | undefined) => {
  return AxiosInstance.get<DistrictUserResponse[]>(`${controller}/${id}/User`);
};

export const getDistrictTitleByType = (id: string | undefined, type: number) => {
  return AxiosInstance.get<DistrictTitleResponse[]>(`${controller}/${id}/Title/${type}`);
};

export const updateDistrictTitle = (id: string | undefined, data: DistrictTitleRequest) => {
  return AxiosInstance.put(`${controller}/${id}/Title`, data);
};

export const getDistrictTitleConfigByType = (id: string | undefined, type: number) => {
  return AxiosInstance.get<DistrictTitleConfigResponse[]>(`${controller}/${id}/TitleConfig/${type}`);
};

export const updateDistrictTitleConfig = (id: string | undefined, type: number, data: DistrictTitleConfigRequest) => {
  return AxiosInstance.put(`${controller}/${id}/TitleConfig/${type}`, data);
};
